export const API_CONFIG = {
    BASE_URL: 'https://delphos-backend-service.delphos.ai/duotone',
    ENDPOINTS: {
        // Authentication
        REQUEST_ACCESS_TOKEN: '/request_access_token',
        NEW_SESSION: '/new_session',

        // Derivative Projects
        PROJECTS: '/derivative/projects',
        DELETE_PROJECT: '/derivative/delete_project',
        NEW_PROJECT: '/derivative/new_project',
        SET_PROJECT_TAGS: '/derivative/set_project_tags',
        UPLOAD: '/derivative/upload',
        DELETE_FILE: '/derivative/delete',
        DOWNLOAD_FILE: '/derivative/download',
        DERIVATIVE_GET_MIDI_URL: '/derivative/get_midi_url',

        // Soundworld Generation
        LIST_SOUNDWORLDS: '/soundworld/listsoundworlds',
        SOUNDWORLD_GET_CLIENT_GENERATIONS: '/soundworld/get_client_generations',
        SOUNDWORLD_GET_GENERATION: '/soundworld/get_generation',
        SOUNDWORLD_NEW_PROJECT: '/soundworld/new_project',
        SOUNDWORLD_PROJECTS: '/soundworld/projects',
        SOUNDWORLD_DELETE_PROJECT: '/soundworld/delete_project',
        SOUNDWORLD_GET_MIDI_URL: '/soundworld/get_midi_url',
        SOUNDWORLD_GET_STEMS: '/soundworld/render_stems',
        SOUNDWORLD_GENERATE: '/soundworld/generate',

        // Derivative Generation & Rendering
        GENERATE: '/derivative/generate',
        RENDER: '/derivative/render',
        RENDER_STEMS: '/derivative/render_stems',
        HAS_AUDIO: '/derivative/has_audio',
        EXECUTE: '/derivative/execute',

        // Audio Utilities
        AUDIO_MASTERING: '/audio/mastering',
        AUDIO_TRANSCRIBE_CHORDS: '/audio/transcribe_chords',
        AUDIO_STEM_SEPARATION: '/audio/stem_separation',
        AUDIO_DRUM_STEMS: '/audio/drum_stems',

        // Credits
        CREDITS: '/credits/credits',
        PAYMENT_LINK: '/credits/payment_link',

        // WebSocket Events
        EVENTS_WS: '/events/ws',
    }
} as const;

export const getAuthHeaders = () => {
    const client_id = localStorage.getItem("client_id");
    const access_token = localStorage.getItem("access_token");
    return {
        'Authorization': `${client_id}:${access_token}`,
        'Content-Type': 'application/json',
    };
};


export const getAuthHeadersWithoutCredentials = () => {
    return getAuthHeaders();
};
